import React, { Component } from 'react'
import XLSX from 'xlsx-style'
import s2ab from './s2ab'
import { groupBy } from 'lodash'


// note this component goes against typical react practice of one way top down data flow to allow
// the user to arbitrarly place sheets and cell components anywhere in the component heirarchy.
// the ancestor components broadcast values up to the WorkBook via context.

export class WorkBook extends Component {

  constructor (props) {
    super(props)
    this.state = { cells: [] }
  }

  getChildContext () {
    return {
      getCell: this.getCell.bind(this),
      getSheet: this.getSheet.bind(this),
      noRender: this.props.noRender,
      toXLSX: this.toXLSX.bind(this)
    }
  }

// only update if children have changed?
  shouldComponentUpdate (nextProps, nextState) {
    return (this.props.children != nextProps.children)
  }

  getSheet (val) {
    debugger
  }

  getCell (val) {
    var { cells } = this.state
    var cell = cells.find(c => (c.cellRef === val.cellRef && c.sheet === val.sheet))

    if (cell) {
      cell = val
    } else {
      cells.push(val)
      this.setState({ cells: cells })
    }
  }

  updateRange (row, col, range) {
    if (range.s.r > row) { range.s.r = row }
    if (range.s.c > col) { range.s.c = col }
    if (range.e.r < row) { range.e.r = row }
    if (range.e.c < col) { range.e.c = col }
    return range
  }

  mapCells (cells) {
    var mapped = {}
    var merges = []
    if (cells.length > 0) {
      var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}}
      cells.forEach(cell => {
        var { cellRef, col, row, data, merge } = cell
        range = this.updateRange(row, col, range)
        if (merge) {
          merges.push(merge)
        }
        mapped[cellRef] = data
      })
      mapped = Object.assign(mapped, {'!ref': XLSX.utils.encode_range(range)}, {'!merges': merges})
    }
    return mapped
  }

  getWB () {
    const { children, title, author, autoColWidth, defaultCellWidth = 50 } = this.props
    var wb
    var sheets = groupBy(this.state.cells, 'sheet')
    if (sheets) {
      wb = { Sheets: {}, SheetNames: [] }
      Object.keys(sheets).forEach(sheet => {
        wb.SheetNames.push(sheet)
        wb.Sheets[sheet] = this.mapCells(sheets[sheet])
        if (autoColWidth) {
          // const fcols = sheets[sheet].filter(cell => cell.row === 0)
          const cols = Object.values(groupBy(sheets[sheet], 'col'))
          wb.Sheets[sheet]['!cols'] = cols.map(col => {
            const width = Math.max.apply(this, col.map(cell => cell.width ? cell.width : defaultCellWidth))
            return {wch: Math.round(width / 20)} // this is a guess!
          })
        }
      }
      )
    }
    return wb
  }

  writeXLSX (wb) {
    const { defaultCellStyle } = this.props
    var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary', defaultCellStyle: defaultCellStyle }
    return XLSX.write(wb, wopts)
  }

  toXLSX (wb = this.getWB()) {
    var blob = new Blob([s2ab(this.writeXLSX(wb))], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
    if (this.props.toXLSXCallback) {
      this.props.toXLSXCallback(blob)
    }
    else {
      return blob
    }
  }

  toJSON (wb = this.getWB()) {
    if (this.props.toJSONCallback) {
      this.props.toJSONCallback(wb)
    }
    else {
      return wb
    }
  }

  render () {
    let { children, generateXLSX = false, toXLSXCallback, noRender } = this.props
    if (generateXLSX && toXLSXCallback) this.toXSLX()
    return <div>
      <button onClick={() => this.toXLSX2()}>download</button>
      {!noRender && <div>{children}</div>}
    </div>
  }

  // recursiveCloneChildren (children) {
  //   return React.Children.map(children, child => {
  //     if (!isObject(child)) return child
  //     var childProps = { children: this.recursiveCloneChildren(child.props.children) }
  //     return React.cloneElement(child, childProps)
  //   })
  // }
}

WorkBook.propTypes = {
  title: React.PropTypes.string,
  author: React.PropTypes.string,
  noRender: React.PropTypes.bool,
  autoColWidth: React.PropTypes.bool,
  toXLSXCallback: React.PropTypes.func,
  toJSONCallback: React.PropTypes.func,
  children: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.array
  ])
}

WorkBook.defaultProps = {
  title: 'generated by react-xlsx',
  author: 'react-xlsx',
  autoColWidth: true
}

WorkBook.childContextTypes = {
  getSheet: React.PropTypes.func,
  getCell: React.PropTypes.func,
  toXLSX: React.PropTypes.func,
  noRender: React.PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/WorkBook.js